<template>
  <div class="h-100">
    <div class="row mb-4">
      <div class="col-md-12">
        <form action="" @submit.prevent class="h-100">
          <ValidationObserver ref="form" v-slot="{}">
            <div class="row d-flex justify-content-between">
              <div class="col-md-4"></div>
              <div class="col-md-4 d-flex justify-content-end">
                <button
                  class="btn btn-filter btn-icon ml-4"
                  type="button"
                  @click.prevent.stop="showFilterModal"
                >
                  <span class="icon icon-filter" /> {{ $t('filter') }}
                </button>
              </div>
            </div>
          </ValidationObserver>
        </form>
      </div>
    </div>

    <div class="row h-100">
      <div class="col-md-12">
        <div v-if="isLoaded">
          <div class="text-center">
            <div
              class="box-block_short box-block text-center"
              v-cloak
              v-if="!registrationsList.length"
            >
              <div class="alert alert-primary">
                {{ $t('emptyRegitrationList') }}
              </div>
            </div>
            <div v-else v-cloak class="dates dates_users">
              <div class="legend">
                <div class="legend__header">
                  {{ $t('legend') }}
                </div>

                <div class="legend__item">
                  <div class="icon icon-success-badge"></div>
                  <div>{{ $t('SucceededStatus') }}</div>
                </div>

                <div class="legend__item">
                  <div class="icon icon-fail-badge"></div>
                  <div>{{ $t('FailedStatus') }}</div>
                </div>

                <div class="legend__item">
                  <div class="icon icon-in-progress-badge"></div>
                  <div>{{ $t('InProgressStatus') }}</div>
                </div>

                <div class="legend__item">
                  <div class="icon icon-not-started"></div>
                  <div>{{ $t('NotStartedStatus') }}</div>
                </div>
              </div>

              <table
                class="table profile-table table-responsive-lg overflow-y-xs text-left"
              >
                <th></th>
                <th>{{ $t('id') }}</th>
                <th>{{ $t('form.name') }}</th>
                <th>{{ $t('courseLanguage') }}</th>
                <th>{{ $t('training') }}</th>
                <th>{{ $t('RegistrationDate') }}</th>
                <!--<th>{{ $t('sessionDate') }}</th>-->
                <th>{{ $t('form.status') }}</th>
                <tbody class="box-block">
                  <registration-row
                    v-for="(registration, index) in registrationsList"
                    :key="'' + registration.id + index"
                    :index="index"
                    :registration="registration"
                    :user="user"
                  ></registration-row>
                </tbody>
              </table>
              <div class="row mt-3 mb-3">
                <div class="col-sm-12 d-flex justify-content-between">
                  <div class="">
                    <button
                      class="btn btn-filter btn-icon"
                      @click="previousPage()"
                    >
                      <span class="icon icon-arrow-left" /> {{ $t('previous') }}
                    </button>
                  </div>
                  <div>{{ $t('pagination', [page, totalPages]) }}</div>
                  <div class="">
                    <button class="btn btn-filter btn-icon" @click="nextPage()">
                      {{ $t('next') }} <span class="icon icon-arrow-right" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="h-100">
          <div
            class="h-100 row d-flex justify-content-center align-items-center"
          >
            <div class="col-12">
              <div class="d-flex justify-content-center align-items-center">
                <div class="spinner-border" role="status">
                  <span class="sr-only"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FilterModal />
    <confirmation-modal></confirmation-modal>
  </div>
</template>

<script>
import ConfirmationModal from '@/js/components/modals/ConfirmationModal.vue'
import RegistrationRow from './RegistrationRow.vue'
import FilterModal from './FilterModal.vue'
import { mapFields } from 'vuex-map-fields'
export default {
  name: 'TraineeRegistrations',
  components: {
    ConfirmationModal,
    RegistrationRow,
    FilterModal,
  },
  data() {
    return {
      page: 1,
      q: '',
      registrationsList: [],
      form: {
        firstname: null,
        lastname: null,
        birthday: null,
        email: null,
        gender: 0,
      },
      isLoaded: false,
      locale: '',
      filterData: {},
      monitor: {
        visible: false,
        message: '',
        type: 'text-warning',
      },
    }
  },
  computed: {
    ...mapFields(['user']),
    ...mapFields([
      'traineeRegistrations.registrations',
      'traineeRegistrations.filtredRegistrations',
      'traineeRegistrations.pagination',
      'traineeRegistrations.limit',
    ]),
    totalPages() {
      return this.$lodash.get(this.pagination, 'total_pages', 1)
    },
  },
  watch: {
    page: (val) => {
      if (val < 1) this.page = 1
    },
    $route: {
      handler(to, from) {
        if (this.$lodash.get(this.$route, 'query', false)) {
          let a = { ...{ page: 1, limit: this.limit }, ...this.$route.query }
          console.log('a watch', a)
          this.getRegistrations(a)
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.filtredRegistrations = []
    this.locale = this.user.local
    this.$bus.$on('registration-filter', (data) => {
      console.log('registration-filter = ', data)
      this.filter(data).then(() => {
        this.filterData.startDate = data.startDate
        this.filterData.endDate = data.endDate
        this.filterData.languge = data.languge
        this.filterData.training = data.training
        this.filterData.status = data.status
        this.$bus.$emit('hide-filter-registration-modal')
      })
    })
  },
  beforeMount() {
    this.$bus.$off('registration-filter')
  },
  methods: {
    showFilterModal() {
      this.$bus.$emit('filter-registration-modal.show')
    },
    nextPage() {
      if (
        this.pagination.total_pages > 1 &&
        this.page < this.pagination.total_pages
      ) {
        this.page++
        let a = {
          ...this.$route.query,
          ...{ page: this.page, limit: this.limit },
          ...{
            startDate: this.filterData?.startDate ?? null,
            endDate: this.filterData?.endDate ?? null,
            languge: this.filterData?.languge ?? null,
            training: this.filterData?.training ?? null,
            status: this.filterData?.status ?? null,
          },
        }
        console.log('a  = ', a)
        this.$router
          .push({ name: 'Registrations', query: a })
          .catch((error) => {})
      }
    },
    previousPage() {
      if (this.pagination.total_pages > 1 && this.page > 1) {
        this.page--
        let a = {
          ...this.$route.query,
          ...{ page: this.page, limit: this.limit },
          ...{
            startDate: this.filterData?.startDate ?? null,
            endDate: this.filterData?.endDate ?? null,
            languge: this.filterData?.languge ?? null,
            training: this.filterData?.training ?? null,
            status: this.filterData?.status ?? null,
          },
        }
        console.log('a  = ', a)
        this.$router
          .push({ name: 'Registrations', query: a })
          .catch((error) => {})
      }
    },
    search() {
      if (this.q != '') {
        this.isLoaded = false
        let payload = {
          params: {
            action: 'search',
            q: this.q,
          },
          id: this.user.id,
        }
        this.$store
          .dispatch('traineeRegistrations/searchRegistrations', payload)
          .then(() => {
            this.registrationsList = this.filtredRegistrations
          })
          .finally(() => {
            this.isLoaded = true
          })
      } else {
        let a = { ...this.$route.query, ...{ page: 1, limit: this.limit } }
        this.filtredRegistrations = []
        this.getRegistrations(a)
      }
    },
    filter(params) {
      this.isLoaded = false
      let payload = {
        params,
      }
      return this.$store
        .dispatch('traineeRegistrations/searchRegistrations', payload)
        .then(() => {
          this.registrationsList = this.filtredRegistrations
        })
        .finally(() => {
          this.isLoaded = true
        })
    },
    getRegistrations(params) {
      console.log('params getRegistrations ', params)
      this.isLoaded = false
      return this.$store
        .dispatch('traineeRegistrations/getRegistrationsByClientId', params)
        .then(() => {
          this.registrationsList = this.registrations
        })
        .finally(() => {
          this.isLoaded = true
        })
    },

    monitorHide() {
      this.monitor.type = ''
      this.monitor.message = ''
      this.monitor.visible = false
    },
  },
}
</script>

<style></style>
